export default __webpack_public_path__ + "513257ae4f6ceb365c92c75644bd74ae.png";